export enum ApplicationStep {
  contact,
  address,
  relationship,
  details,
  review,
}
